import React from "react";

export function FormBox({ children }) {
  return <div style={{ padding: 10, width: "100%" }}>{children}</div>;
}
